interface LogoProps {
  className?: string;
}

export function Logo({ className = "w-10 h-10" }: LogoProps) {
  return (
    <svg 
      className={className}
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background circle */}
      <circle cx="50" cy="50" r="48" fill="#008751"/>
      
      {/* Lightning bolt - simple and bold */}
      <path 
        d="M55 20 L35 52 H48 L45 80 L65 48 H52 L55 20 Z" 
        fill="white"
      />
    </svg>
  );
}